exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-automation-contenteditable[data-v-2f69a1c6]{min-width:0;width:100%}.fts-automation-contenteditable .automation-contenteditable[data-v-2f69a1c6]{display:flex;align-items:center}.fts-automation-contenteditable .automation-contenteditable-control[data-v-2f69a1c6]{width:auto}.fts-automation-contenteditable .automation-contenteditable-action[data-v-2f69a1c6]{margin-left:.375rem;color:#9e9e9e;cursor:pointer}", ""]);

// exports
